<script>
import { mapState, mapActions } from "vuex";
import AppIconBase from "./AppIconBase.vue";

export default {
  data() {
    return {
      activeVideos: [],
    };
  },
  components: {
    AppIconBase,
  },
  computed: {
    ...mapState(["modalAttr"]),
    videoURL() {
      if (this.modalAttr.modalVideo !== null) {
        const srcStr = this.modalAttr.modalVideo;
        return srcStr.split(/v\d{5,12}/);
      } else {
        return "";
      }
      v;
      return "";
    },
  },
  methods: {
    ...mapActions(["toggleModal"]),
    closeModal() {
      this.activeVideos.forEach((video) => {
        video.play();
      });
      this.toggleModal(null);
    },
  },
  mounted() {
    const allVideos = document.querySelectorAll("video");
    allVideos.forEach((video) => {
      if (video.paused === false) {
        video.pause();
        this.activeVideos.push(video);
      }
    });
  },
};
</script>

<template>
  <div class="overlay" @click="closeModal" allowfullscreen>
    <div class="videoContainer">
      <AppIconBase @click="closeModal" name="CloseIcon" class="closeBtn" />

      <iframe
        allowfullscreen
        allow="autoplay; fullscreen; picture-in-picture"
        :src="`https://player.vimeo.com/video/${this.modalAttr.vimeoId}?autoplay=1`"
        data-ot-ignore
      ></iframe>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";
iframe {
  width: 100%;
  height: auto;
  border: 0;
  outline: none;
}
.overlay {
  --plyr-color-main: #00bcb4;
  --aspecRatio: 0.5625;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 54444444444;
}
.videoContainer {
  --videoW: 90vw;
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  width: var(--videoW);
  height: calc(var(--videoW) * var(--aspecRatio));
  iframe {
    height: 100% !important;
  }
}
@media (orientation: landscape) and (max-width: 1000px) {
  .videoContainer {
    --videoW: 70vw;
  }
}
.closeBtn {
  background-color: transparent;
  border: 0;
  color: white;
  cursor: pointer;
  font-size: 30px;
  height: 29px;
  position: absolute;
  right: -5px;
  text-align: center;
  top: -30px;
  width: 20px;
}
.videoP,
.plyr--video {
  margin-left: 0;
  margin-right: 0;
  height: 100%;
  z-index: 2000;
  width: 100%;
}
@include mq($from: md) {
  .videoContainer {
    --videoW: 75vw;
    //  width: 60vw;
    // height: 33.74vw;
    margin-top: 40px;
    iframe {
      height: 100% !important;
    }
  }
  .closeBtn {
    background-color: transparent;
    border: 0;
    color: white;
    cursor: pointer;
    font-size: 30px;
    height: 16px;
    position: absolute;
    right: -25px;
    text-align: center;
    top: -25px;
    width: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppModal.vue